import { axios } from 'setup/axiosSetup';

// Keno runs on its own provider server, like Lucky Six; our API opens the
// session (POST /keno/launch) and tells whether this player may see it
// (everyone, unless staff switched it off for the player).

const baseUrl = (): string => process.env.REACT_APP_GAME_API_BACKEND_API ?? '';

export const getKenoAccess = async (): Promise<boolean> => {
  const response = await axios.get(`${baseUrl()}/keno/access`, {
    cache: false,
  });
  return !!response.data?.enabled;
};

export const launchKeno = async (
  lang: string,
  channel: 'web' | 'mobile'
): Promise<string> => {
  const response = await axios.post(
    `${baseUrl()}/keno/launch`,
    { lang, channel },
    { cache: false }
  );
  return response.data.launch_url as string;
};
